export const columns = [
  {
    Header: 'ID',
    accessor: 'id',
  },
  {
    Header: 'Date',
    accessor: 'date_report'
  },
  {
    Header: 'Task',
    accessor: 'task',
  },
  {
    Header: 'Hours',
    accessor: 'hours',
  },
  {
    Header: 'Project',
    accessor: 'project_id',
  },
  {
    Header: 'Actions',
    accessor: 'actions',
    disableSortBy: true,
    disableGlobalFilter: true,
  },
];